// ControllerSupport.tsx
// Copyright (c) 2020 Neomantra Corp

import React from 'react'

const clearTimers = (requestTimer: any, errorTimer: any, setErrorMsg: any) => {
        requestTimer.current ? clearTimeout(requestTimer.current) : null
        errorTimer.current ? clearTimeout(errorTimer.current) : null
        setErrorMsg('')
    },
    startRequestTimer = (requestTimer: any, errorTimer: any, setErrorMsg: any, setIsLoading: any, waitForResponseTime: any, errorMsgTime: any) => {
        clearTimers(requestTimer, errorTimer, setErrorMsg)
        requestTimer.current = setTimeout(() => {
            startErrorTimer(requestTimer, errorTimer, setErrorMsg, errorMsgTime)
            setIsLoading(false)
        }, waitForResponseTime)
    },
    startErrorTimer = (requestTimer: any, errorTimer: any, setErrorMsg: any, errorMsgTime: any) => {
        clearTimers(requestTimer, errorTimer, setErrorMsg)
        setErrorMsg('Request may be invalid')
        errorTimer.current = setTimeout(() => {
            setErrorMsg('')
        }, errorMsgTime)
    },
    // https://joshwcomeau.com/react/persisting-react-state-in-localstorage/
    useStickyState = (defaultValue: any, key: any) => {
        const [value, setValue] = React.useState(() => {
            const stickyValue = window.localStorage.getItem(key)
            return stickyValue !== null ? JSON.parse(stickyValue) : defaultValue
        })
        React.useEffect(() => {
            window.localStorage.setItem(key, JSON.stringify(value))
        }, [key, value])
        return [value, setValue]
    }

export { clearTimers, startRequestTimer, startErrorTimer, useStickyState }
